/*!
 * Copyright © 2018. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Component, Input, EventEmitter, Output } from '@angular/core';

import { IGarminBalloon } from '../../../core/models';

@Component({
  selector: 'fm-garmin-balloon',
  templateUrl: './garmin-balloon.component.html',
  styleUrls: ['./garmin-balloon.component.scss']
})
export class GarminBalloonComponent {
  @Input()
  public balloon: IGarminBalloon;
  @Input()
  public isStreetViewAvailable: boolean;

  @Output()
  public streetViewClicked = new EventEmitter<IGarminBalloon>();
  @Output()
  public zoomTo = new EventEmitter<IGarminBalloon>();

  public onStreetView(): void {
    this.streetViewClicked.emit(this.balloon);
  }

  public onZoomTo(): void {
    this.zoomTo.emit(this.balloon);
  }
}
